import React from 'react';

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, redirect, RouterProvider } from 'react-router';

import type { AnalyticsRouteHandle } from '@helsenorge/core-framework/track-pageview/useTrackPageView';
import { getPath } from '@helsenorge/framework-utils/hn-page';
import { getHelsenorgeUrl } from '@helsenorge/framework-utils/hn-proxy-service';

import '@helsenorge/designsystem-react/scss/helsenorge.scss';

import BehandlingsvalgPage from './behandlingsvalg';
import PageContainer from './page-container';
import { store } from './store';
import VerktoyPage from './verktoy';

async function enableMocking(): Promise<ServiceWorkerRegistration | void> {
  if (import.meta.env.MODE !== 'mocks') {
    return;
  }

  const { worker } = await import('./mocks/browser');

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

enableMocking().then(() => {
  const router = createBrowserRouter(
    [
      {
        path: '/',
        loader: (): Response => redirect(`${getHelsenorgeUrl()}/samvalg`),
      },
      {
        path: '/:verktoynavn',
        element: (
          <PageContainer>
            <VerktoyPage />
          </PageContainer>
        ),
        handle: {
          analytics: {
            path: (path): string => path,
          },
        } satisfies AnalyticsRouteHandle,
      },
      {
        path: '/:verktoynavn/:behandlingsvalgnavn',
        element: (
          <PageContainer>
            <BehandlingsvalgPage />
          </PageContainer>
        ),
        handle: {
          analytics: {
            path: (path): string => path,
          },
        } satisfies AnalyticsRouteHandle,
      },
    ],
    { basename: '/' + getPath() }
  );

  ReactDOM.createRoot(document.getElementById('main-content-wrapper')!).render(
    <React.StrictMode>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </React.StrictMode>
  );
});
